"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.TooltipPlacement = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Tooltip_style_1 = require("./Tooltip.style");
var TooltipPlacement;
(function (TooltipPlacement) {
    TooltipPlacement["BOTTOM_END"] = "bottom-end";
    TooltipPlacement["BOTTOM_START"] = "bottom-start";
    TooltipPlacement["BOTTOM"] = "bottom";
    TooltipPlacement["LEFT_END"] = "left-end";
    TooltipPlacement["LEFT_START"] = "left-start";
    TooltipPlacement["LEFT"] = "left";
    TooltipPlacement["RIGHT_END"] = "right-end";
    TooltipPlacement["RIGHT_START"] = "right-start";
    TooltipPlacement["RIGHT"] = "right";
    TooltipPlacement["TOP_END"] = "top-end";
    TooltipPlacement["TOP_START"] = "top-start";
    TooltipPlacement["TOP"] = "top";
})(TooltipPlacement = exports.TooltipPlacement || (exports.TooltipPlacement = {}));
var Tooltip = function (_a) {
    var title = _a.title, customClasses = _a.customClasses, children = _a.children, disabled = _a.disabled, placement = _a.placement, arrow = _a.arrow;
    var classes = customClasses ? customClasses : (0, Tooltip_style_1.TooltipStyles)();
    return (react_1.default.createElement(core_1.Tooltip, { title: title, placement: placement, classes: {
            tooltip: classes.tooltip,
            arrow: classes.arrow,
            tooltipPlacementLeft: classes.tooltipPlacementLeft,
            tooltipPlacementRight: classes.tooltipPlacementRight,
        }, arrow: arrow, disableHoverListener: disabled }, children));
};
exports.Tooltip = Tooltip;
